
const KEY = "adm_client_ip";
const FRESH_MS = 30 * 60 * 1000;
const RETRY_MS = 10 * 60 * 1000;
const TIMEOUT_MS = 3000;

let inflight = null;

function readCache() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

function writeCache(ip) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ip: ip || "", ts: Date.now() }));
  } catch {
    // a blocked storage just means asking again next time
  }
}

async function fetchIp() {
  let ip;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const res = await fetch("https://api.ipify.org?format=json", { signal: controller.signal });
    ip = (await res.json())?.ip || undefined;
  } catch {
    ip = undefined;
  } finally {
    clearTimeout(timer);
  }
  // A failure is remembered too, so a blocked ipify is not retried on every click.
  writeCache(ip);
  return ip;
}

export function getClientIp() {
  const cached = readCache();
  if (cached && Date.now() - cached.ts < (cached.ip ? FRESH_MS : RETRY_MS)) {
    return Promise.resolve(cached.ip || undefined);
  }
  if (!inflight) {
    inflight = fetchIp().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}
